const outputs = {
  outputs: 'Outputs',
  table: {
    displayName: 'Display name',
    serialNumber: 'Serial number',
    enabled: 'Enabled',
    searchPlaceHolder: 'Display name / serial number',
  },
  modal: {
    title: 'Output properties',
    tabInformation: 'General Information',
    tabEvents: 'Events',
  },
  form: {
    checkEnable: 'Enable',
    radioNormallyOpen: 'Normally open',
    radioNormallyClose: 'Normally close',
  },
};

export default outputs;
